export enum MessageActionType {
    BUTTON = 'button',
}
